module.exports = __webpack_public_path__ + "img/J2.f796c2e7.png";